export default __webpack_public_path__ + "static/media/Emotional06.923be225.png";